<template>
  <div>
    <Menu />

    <header class="hero hero-dev">
      <div class="container">
        <div class="hero-topbar d-flex align-items-center justify-content-between">
          <div class="brand-lockup">
            <a href="/home" class="d-flex align-items-center text-decoration-none">
              <img src="https://www.stratitude.co.za/chas-international/dubai/images/chas-logo.svg" alt="Chas Everitt" class="brand-logo" loading="lazy" />
            </a>

            <span class="brand-divider d-none d-md-inline-block" aria-hidden="true"></span>

            <div class="d-none d-md-block">
              <a href="https://www.leadingre.com/" class="d-flex align-items-center text-decoration-none" target="_blank" rel="noopener noreferrer">
                <img src="https://www.stratitude.co.za/chas-international/dubai/images/leading-logo1.png" alt="Leading Real Estate" class="partner-logo" loading="lazy" />
              </a>
            </div>
          </div>

          <nav class="d-none d-lg-flex hero-nav align-items-center">
            <a class="nav-link" href="/properties">Buy</a>
            <a class="nav-link" href="/sell">Sell</a>
            <a class="nav-link" href="/developments">Developments</a>
            <a class="nav-link" href="/commercial">Commercial</a>
          </nav>

          <button class="btn hamburger d-lg-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#mobileNav">
            <i class="bi bi-list" style="font-size:1.25rem;"></i>
          </button>
        </div>

        <div class="pt-5 pb-4">
          <h1 class="hero-title mb-3">
            Looking to invest<br />in <strong>new developments?</strong>
          </h1>

          <!-- <div class="d-flex hero-tabs">
            <a href="#" class="active">Dubai</a>
            <a href="https://www.chaseveritt.co.zw/">Zimbabwe</a>
            <a href="#">Mauritius</a>
            <a href="https://www.chaseveritt.co.za/">South Africa</a>
          </div> -->
        </div>
      </div>
    </header>

    <section class="search-strip">
      <div class="container">
        <form class="row g-2 align-items-center search-strip-desktop" @submit.prevent="applySearch">
          <div class="col-12 col-md-6 col-xl-3">
            <select class="form-select" v-model="selectedLocation">
              <option value="">LOCATION</option>
              <option v-for="location in locationOptions" :key="location" :value="location">
                {{ location }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-3">
            <select class="form-select" v-model="selectedType">
              <option value="">DEVELOPMENT TYPE</option>
              <option v-for="type in typeOptions" :key="type" :value="type">
                {{ type }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-2">
            <select class="form-select" v-model="selectedStatus">
              <option value="">STATUS</option>
              <option v-for="status in statusOptions" :key="status" :value="status">
                {{ status }}
              </option>
            </select>
          </div>

          <div class="col-12 col-md-6 col-xl-2">
            <select class="form-select" v-model.number="selectedMaxPrice">
              <option :value="0">MAX PRICE</option>
              <option v-for="price in priceOptions" :key="price" :value="price">
                {{ formatCurrency(price) }}
              </option>
            </select>
          </div>

          <div class="col-12 col-xl-2">
            <button class="btn btn-primary w-100 search-submit-btn" type="submit">
              Search
            </button>
          </div>
        </form>
      </div>
    </section>

    <section class="statement-band">
      <div class="container">
        <p class="statement-title">There is no better place to build</p>
        <p class="statement-sub">Access to international capital and investors</p>
      </div>
    </section>

    <section id="developments-results" class="py-5 bg-white">
      <div class="container">
        <div class="d-flex flex-wrap align-items-end justify-content-between gap-3 mb-3">
          <div>
            <div class="section-title">Latest Developments</div>
            <div class="section-rule"></div>
          </div>

          <div v-if="!loading" class="text-md-end">
            <p class="mb-2 results-count">
              Showing {{ filteredDevelopments.length }} of {{ developments.length }} developments
            </p>

            <button type="button" class="btn btn-outline-secondary btn-sm" @click="clearFilters" v-if="hasActiveFilters">
              Clear filters
            </button>
          </div>
        </div>

        <div v-if="loading" class="py-4">
          Loading developments...
        </div>

        <div v-else-if="developments.length == 0" class="empty-card">
          <h2>No developments currently listed</h2>
          <p>
            There are currently no Dubai developments available. Please check back soon.
          </p>
        </div>

        <div v-else-if="filteredDevelopments.length == 0" class="empty-card">
          <h2>No matching developments found</h2>
          <p>
            We have developments available, but none match your current filters.
          </p>
          <button type="button" class="btn btn-primary" @click="clearFilters">
            View all developments
          </button>
        </div>

        <div v-else class="row g-4">
          <div class="col-12 col-md-12 col-lg-4" v-for="development in filteredDevelopments" :key="development.key">
            <article class="listing-card h-100 development-card">
              <a class="listing-card__media" :href="developmentHref(development)">
                <div class="listing-img" :style="{ backgroundImage: 'url(' + developmentImage(development) + ')' }"></div>
              </a>

              <div class="listing-meta text-start">
                <div class="listing-title">
                  <strong>{{ cleanText(development.title) }}</strong>
                </div>

                <div class="listing-price">
                  <div>{{ priceRange(development) }}</div>

                  <template v-if="hasConvertedDevelopmentPrice(development)">
                    <div class="converted-price">
                      Approx. {{ convertedPriceRange(development, 'ZAR') }}
                    </div>
                    <div class="converted-price">
                      Approx. {{ convertedPriceRange(development, 'USD') }}
                    </div>
                  </template>
                </div>

                <p class="listing-desc">
                  {{ developmentLocation(development) }}
                </p>

                <div class="listing-tags">
                  <span v-if="development.type">{{ development.type }}</span>
                  <span v-if="development.status">{{ development.status }}</span>
                  <span v-if="development.properties && development.properties.length">
                    {{ development.properties.length }} Properties
                  </span>
                </div>
              </div>

              <div class="listing-cta">
                <a class="link-view" :href="developmentHref(development)">
                  View
                </a>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>

    <div class="offcanvas offcanvas-end offcanvas-custom" tabindex="-1" id="mobileNav" aria-labelledby="mobileNavLabel">
      <div class="offcanvas-header">
        <h5 class="offcanvas-title text-white" id="mobileNavLabel">Menu</h5>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>

      <div class="offcanvas-body">
        <div class="list-group list-group-flush">
          <a class="list-group-item list-group-item-action" href="/properties">Buy</a>
          <a class="list-group-item list-group-item-action" href="/sell">Sell</a>
          <a class="list-group-item list-group-item-action" href="/developments">Developments</a>
          <a class="list-group-item list-group-item-action" href="/commercial">Commercial</a>
        </div>
        <hr />
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import axios from 'axios'
import Menu from '@/components/Menu.vue'
import Footer from '@/components/Footer.vue'

export default {
  components: {
    Menu,
    Footer
  },

  data() {
    return {
      loading: true,
      currencyRates: null,
      rawDevelopments: [],
      imageBaseUrl: 'https://luxury-dev.chaseveritt.co.za/',
      selectedLocation: '',
      selectedType: '',
      selectedStatus: '',
      selectedMaxPrice: 0
    }
  },

  mounted() {
    this.setFiltersFromRoute()
    this.fetchCurrencyRates()
    this.fetchDevelopments()
  },

  watch: {
    '$route.query': {
      handler() {
        this.setFiltersFromRoute()
      },
      deep: true
    }
  },

  computed: {
    developments() {
      return this.rawDevelopments
        .map((item) => {
          const development = this.extractDevelopment(item)
          const meta = item && item.meta ? item.meta : {}

          if (!development) {
            return null
          }

          development.meta = meta
          development.key = this.developmentKey(development, meta)

          return development
        })
        .filter((development) => {
          return development
        })
    },

    filteredDevelopments() {
      return this.developments.filter((development) => {
        if (this.selectedLocation != '') {
          const location = this.developmentLocation(development).toLowerCase()

          if (location.indexOf(this.selectedLocation.toLowerCase()) === -1) {
            return false
          }
        }

        if (this.selectedType != '') {
          if (this.safeString(development.type).toLowerCase() != this.selectedType.toLowerCase()) {
            return false
          }
        }

        if (this.selectedStatus != '') {
          if (this.safeString(development.status).toLowerCase() != this.selectedStatus.toLowerCase()) {
            return false
          }
        }

        if (this.selectedMaxPrice > 0) {
          const low = this.priceNumber(development.low_price)

          if (low > 0 && low > this.selectedMaxPrice) {
            return false
          }
        }

        return true
      })
    },

    locationOptions() {
      const values = this.developments
        .map((development) => {
          return this.developmentLocation(development)
        })
        .filter((value) => {
          return value != ''
        })

      return Array.from(new Set(values)).sort()
    },

    typeOptions() {
      return this.uniqueOptions('type')
    },

    statusOptions() {
      return this.uniqueOptions('status')
    },

    priceOptions() {
      const prices = this.developments
        .map((development) => {
          return this.priceNumber(development.low_price)
        })
        .filter((price) => {
          return price > 0
        })

      const rounded = prices.map((price) => {
        if (price <= 1000000) {
          return Math.ceil(price / 100000) * 100000
        }

        return Math.ceil(price / 1000000) * 1000000
      })

      return Array.from(new Set(rounded)).sort((a, b) => {
        return a - b
      })
    },

    hasActiveFilters() {
      if (this.selectedLocation != '') {
        return true
      }

      if (this.selectedType != '') {
        return true
      }

      if (this.selectedStatus != '') {
        return true
      }

      if (this.selectedMaxPrice > 0) {
        return true
      }

      return false
    }
  },

  methods: {
    async fetchCurrencyRates() {
      try {
        const response = await axios.get(
          'https://chas-dubai.stratitude-develop.co.za/api/fetch-currency-rates.php'
        )

        if (!response.data || response.data.success !== true) {
          return
        }

        this.currencyRates = {
          aedToZar: response.data.aedToZar,
          aedToUsd: response.data.aedToUsd,
          updatedAt: response.data.updatedAt,
          cachedAt: response.data.cachedAt
        }
      } catch (error) {
        console.log(error)
        this.currencyRates = null
      }
    },

    async fetchDevelopments() {
      this.loading = true

      try {
        const response = await axios.get(
          'https://chas-dubai.stratitude-develop.co.za/api/fetch-developments.php',
          {
            headers: {
              Accept: 'application/json'
            }
          }
        )

        const payload = response && response.data ? response.data : {}

        if (payload && Array.isArray(payload.developments)) {
          this.rawDevelopments = payload.developments.filter((item) => {
            const metaSite = item && item.meta && item.meta.site
              ? item.meta.site.toString().toLowerCase()
              : ''

            const development = this.extractDevelopment(item)

            const developmentSite = development && development.site
              ? development.site.toString().toLowerCase()
              : ''

            return (
              metaSite == 'international-dubai' ||
              metaSite == 'dubai' ||
              developmentSite == 'international-dubai' ||
              developmentSite == 'dubai'
            )
          })
        } else {
          this.rawDevelopments = []
        }
      } catch (error) {
        console.log(error)
        this.rawDevelopments = []
      }

      this.loading = false
    },

    extractDevelopment(item) {
      if (!item) {
        return null
      }

      if (
        item.development &&
        item.development.data &&
        item.development.data.development &&
        item.development.data.development[0]
      ) {
        return Object.assign({}, item.development.data.development[0])
      }

      if (item.development && item.development.title) {
        return Object.assign({}, item.development)
      }

      if (item.title) {
        return Object.assign({}, item)
      }

      return null
    },

    developmentKey(development, meta) {
      if (meta && meta.ref_id) {
        return meta.ref_id
      }

      if (development.ref_id) {
        return development.ref_id
      }

      if (development.id) {
        return development.id
      }

      return this.slugify(development.title)
    },

    developmentHref(development) {
      if (development.slug) {
        return '/development/' + development.slug
      }

      if (development.meta && development.meta.slug) {
        return '/development/' + development.meta.slug
      }

      if (development.ref_id) {
        return '/development/' + development.ref_id
      }

      return '/development/' + this.developmentKey(development, development.meta || {})
    },

    developmentImage(development) {
      if (development.cover_image) {
        return this.getImageUrl(development.cover_image)
      }

      if (development.image_gallery && development.image_gallery.length > 0) {
        if (development.image_gallery[0].url) {
          return this.getImageUrl(development.image_gallery[0].url)
        }
      }

      return 'https://www.stratitude.co.za/chas-international/dubai/images/placeholder.jpg'
    },

    developmentLocation(development) {
      return development.location ||
        development.loc_region ||
        development.loc_suburb ||
        development.city ||
        development.area ||
        'Dubai'
    },

    priceRange(development) {
      const low = this.priceNumber(development.low_price)
      const high = this.priceNumber(development.high_price)

      if (low > 0 && high > 0) {
        return this.formatCurrency(low) + ' - ' + this.formatCurrency(high)
      }

      if (low > 0) {
        return 'From ' + this.formatCurrency(low)
      }

      return 'POA'
    },

    getImageUrl(path) {
      if (!path) {
        return 'https://www.stratitude.co.za/chas-international/dubai/images/placeholder.jpg'
      }

      if (path.indexOf('http') === 0) {
        return path
      }

      return this.imageBaseUrl.replace(/\/$/, '') + '/' + path.replace(/^\//, '')
    },

    uniqueOptions(field) {
      const values = this.developments
        .map((development) => {
          return development[field]
        })
        .filter((value) => {
          return value
        })

      return Array.from(new Set(values)).sort()
    },

    hasConvertedDevelopmentPrice(development) {
      if (!development) {
        return false
      }

      if (!this.currencyRates) {
        return false
      }

      const low = this.priceNumber(development.low_price)
      const high = this.priceNumber(development.high_price)

      if (low > 0 || high > 0) {
        return true
      }

      return false
    },

    convertedPriceRange(development, currency) {
      if (!this.hasConvertedDevelopmentPrice(development)) {
        return ''
      }

      const low = this.priceNumber(development.low_price)
      const high = this.priceNumber(development.high_price)

      if (low > 0 && high > 0) {
        return this.formatConvertedCurrency(low, currency) + ' - ' + this.formatConvertedCurrency(high, currency)
      }

      if (low > 0) {
        return 'From ' + this.formatConvertedCurrency(low, currency)
      }

      if (high > 0) {
        return 'Up to ' + this.formatConvertedCurrency(high, currency)
      }

      return ''
    },

    formatConvertedCurrency(value, currency) {
      const amount = this.priceNumber(value)

      if (amount == 0 || !this.currencyRates) {
        return ''
      }

      if (currency == 'ZAR') {
        return new Intl.NumberFormat('en-ZA', {
          style: 'currency',
          currency: 'ZAR',
          maximumFractionDigits: 0
        }).format(amount * this.currencyRates.aedToZar)
      }

      if (currency == 'USD') {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          maximumFractionDigits: 0
        }).format(amount * this.currencyRates.aedToUsd)
      }

      return ''
    },

    applySearch() {
      const query = {}

      if (this.selectedLocation != '') {
        query.location = this.selectedLocation
      }

      if (this.selectedType != '') {
        query.type = this.selectedType
      }

      if (this.selectedStatus != '') {
        query.status = this.selectedStatus
      }

      if (this.selectedMaxPrice > 0) {
        query.max_price = this.selectedMaxPrice
      }

      if (this.$router) {
        this.$router.push({
          path: '/developments',
          query: query
        })
      }

      this.scrollToResults()
    },

    setFiltersFromRoute() {
      const query = this.$route && this.$route.query ? this.$route.query : {}

      this.selectedLocation = query.location || ''
      this.selectedType = query.type || ''
      this.selectedStatus = query.status || ''
      this.selectedMaxPrice = this.priceNumber(query.max_price || 0)
    },

    clearFilters() {
      this.selectedLocation = ''
      this.selectedType = ''
      this.selectedStatus = ''
      this.selectedMaxPrice = 0

      if (this.$router) {
        this.$router.push({
          path: '/developments',
          query: {}
        })
      }
    },

    scrollToResults() {
      this.$nextTick(() => {
        const el = document.getElementById('developments-results')

        if (el) {
          el.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          })
        }
      })
    },

    formatCurrency(value) {
      const amount = this.priceNumber(value)

      if (amount == 0) {
        return 'AED 0'
      }

      return new Intl.NumberFormat('en-AE', {
        style: 'currency',
        currency: 'AED',
        maximumFractionDigits: 0
      }).format(amount)
    },

    priceNumber(value) {
      const number = Number(String(value || '').replace(/[^0-9.-]+/g, ''))

      if (isNaN(number)) {
        return 0
      }

      return number
    },

    safeString(value) {
      if (!value) {
        return ''
      }

      return value.toString()
    },

    slugify(value) {
      if (!value) {
        return 'development'
      }

      return value
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '')
        .replace(/-+/g, '-')
    },

    cleanText(value) {
      if (!value) {
        return ''
      }

      return value
        .toString()
        .replace(/ΓÇö/g, '—')
        .replace(/ΓÇô/g, '–')
        .replace(/ΓÇÖ/g, '’')
        .replace(/ΓÇ£/g, '“')
        .replace(/ΓÇ¥/g, '”')
        .replace(/ΓÇó/g, '•')
        .replace(/Γ£ö∩╕Å/g, '✓')
        .replace(/≡ƒôì/g, '📍')
        .replace(/ΓÇª/g, '…')
        .replace(/┬á/g, ' ')
        .replace(/&amp;/g, '&')
    }
  }
}
</script>

<style scoped>
.search-submit-btn {
  border-radius: 0 !important;
  height: 46px;
  font-size: .78rem;
  letter-spacing: .05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.results-count {
  color: #555;
  font-size: 14px;
}

.listing-img {
  width: 100%;
  height: 300px;
  background-size: cover;
  background-position: center;
}

.listing-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 12px;
}

.listing-tags span {
  background-color: #255699;
  color: #fff;
  font-size: 11px;
  font-weight: bold;
  padding: 5px 12px;
}

.empty-card {
  background: #f7f7f7;
  border-radius: 18px;
  padding: 42px;
  text-align: center;
}

.empty-card h2 {
  font-size: 28px;
  font-weight: 800;
  color: #333;
}

.empty-card p {
  max-width: 560px;
  margin: 0 auto 22px;
  color: #555;
}

.development-card {
  overflow: hidden;
}

@media (min-width: 1200px) {
  .search-strip-desktop {
    flex-wrap: nowrap;
  }

  .search-strip-desktop .form-select,
  .search-strip-desktop .btn {
    height: 46px;
  }
}

.gallery-modal {
  background: #111;
  color: #fff;
  height: 100vh;
}

.gallery-modal .modal-body {
  overflow-y: auto;
  min-height: 0;
}

.gallery-modal .modal-content {
  height: 100vh;
}
.converted-price {
  font-size: 0.85em;
  font-weight: 400;
  opacity: 0.75;
  line-height: 1.3;
}

</style>